import React from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { Badge } from './ui/badge';

const FAQAccordion = ({ faqs }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <Badge className="bg-[#2F80ED] text-white mb-4">FAQ</Badge>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0B2A4A] mb-4">
              Questions fréquentes
            </h2>
            <p className="text-lg text-gray-600">
              Retrouvez les réponses aux questions les plus courantes sur nos services.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 md:p-8 border border-gray-200">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => (
                <AccordionItem key={index} value={`item-${index}`}>
                  <AccordionTrigger className="text-left hover:text-[#2F80ED] transition-colors">
                    <div className="flex items-start gap-3">
                      <HelpCircle className="w-5 h-5 text-[#2F80ED] flex-shrink-0 mt-0.5" />
                      <span className="font-semibold text-[#0B2A4A]">{faq.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent>
                    <div className="pl-8 pr-4 pt-2 pb-4">
                      <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                    </div>
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>

          <div className="mt-8 text-center">
            <p className="text-gray-600 mb-4">Vous avez une autre question ?</p>
            <a 
              href="tel:0644182790"
              className="inline-flex items-center gap-2 text-[#2F80ED] hover:text-[#0B2A4A] font-semibold transition-colors"
            >
              Appelez-nous au 06 44 18 27 90
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
